import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

const sanitizeVideoCategoryItem = (item = {}) => {
  const { order, parent_videocategory_id, ...rest } = item;
  return rest;
};

const sanitizeVideoCategoryPayload = (payload) => {
  if (Array.isArray(payload)) {
    return payload.map((item) => sanitizeVideoCategoryItem(item));
  }

  if (Array.isArray(payload?.data)) {
    return {
      ...payload,
      data: payload.data.map((item) => sanitizeVideoCategoryItem(item)),
    };
  }

  return payload;
};

/**
 * @name videoCategoryList
 * @description Get the list of video categories
 * @param {string} query
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const videoCategoryList = async (query) => {
  const response = await apiClient.request('GET', `/admin/video-category${query || ''}`);
  if (!isApiResponseError(response)) {
    return sanitizeVideoCategoryPayload(response?.data);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name parentVideoCategory
 * @description Get the list of parent video categories
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {array} response.data
 */
export const parentVideoCategory = async () => {
  const response = await apiClient.request('GET', '/admin/parent-videocategory');
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
